




























import { ProjectProperty } from "@/api/project-api";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import DEFAULT_KEY_NAME from "@/constant/property";
import { ProjectPropertyKey } from "@/api/project/project-properties-api";
import { getProjectPropertyKeys } from "@/api/project/project-properties-api";

@Component({
  model: { prop: "defaultValues" }
})
export default class ProjectPropertiesForm extends Vue {
  @Prop({ required: true }) defaultValues!: ProjectProperty[];

  values: ProjectProperty[] = [];
  DEFAULT_KEY_NAME = DEFAULT_KEY_NAME;
  defaultKey: ProjectPropertyKey[] = [];
  keyValue: string = "";

  get availableValues(): ProjectProperty[] {
    return this.values;
  }

  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged(defaultValues: ProjectProperty[]) {
    this.values = cloneDeep(defaultValues);
  }

  getValue() {
    const defaultKeyFiltered = this.values.filter(
      item => item.key.name === DEFAULT_KEY_NAME
    );
    if (defaultKeyFiltered[0]) {
      this.keyValue = defaultKeyFiltered[0].value;
    }
  }

  private async propertyKeyDefault() {
    const data = await getProjectPropertyKeys();

    return data.filter(
      item => item.name === DEFAULT_KEY_NAME && !item.deletedAt
    );
  }

  get autoNumberType() {
    if (this.defaultKey[0]) {
      return this.defaultKey[0].project_no_method;
    }

    return false;
  }

  mounted() {
    this.propertyKeyDefault().then(res => {
      this.defaultKey = res;
    });

    this.getValue();
  }

  defaultKeyValue(name: String): boolean | undefined {
    return this.autoNumberType && name === DEFAULT_KEY_NAME;
  }

  isDisabledDefaultKey(name: string): boolean {
    return !this.autoNumberType && name === DEFAULT_KEY_NAME && !!this.keyValue;
  }
}
